export const environment = {
  production: true,
  mock: false,
  auth: {
    storageKey: 'd8sa6gd'
  },
  version: '1.1.95'
};
